import { jsx as e, jsxs as t, Fragment as f } from "react/jsx-runtime";
import { useRef as B, useState as y, Fragment as C } from "react";
import { useOutsideAlerter as P } from "../../../hooks/useOutsideAlerter.js";
import R from "../../forms/base.js";
import F from "../../forms/input/index.js";
import { HashtagSvg as I, LocationMarketSvg as V, PersonSvg as L, SearchSvg as j, LoadingGif as H } from "../../icons/index.js";
import { debounce as k } from "../../../utils/debounce.js";
function D({
  children: r,
  onClick: a
}) {
  return /* @__PURE__ */ e(
    o,
    {
      iconContent: /* @__PURE__ */ e("img", { src: I, className: "b-h-full b-w-full" }),
      onClick: a,
      children: r
    }
  );
}
function E({
  children: r,
  onClick: a
}) {
  return /* @__PURE__ */ e(
    o,
    {
      iconContent: /* @__PURE__ */ e("img", { src: V, className: "b-h-full b-w-full" }),
      onClick: a,
      children: r
    }
  );
}
function J({
  children: r,
  onClick: a
}) {
  return /* @__PURE__ */ e(
    o,
    {
      iconContent: /* @__PURE__ */ e("img", { src: L, className: "b-h-full b-w-full" }),
      onClick: a,
      children: r
    }
  );
}
function o({
  iconContent: r,
  children: a,
  onClick: s
}) {
  return /* @__PURE__ */ t(
    "li",
    {
      className: "hover:b-bg-gray-200 hover:b-cursor-pointer b-flex b-items-center b-gap-1 b-px-3 b-py-2",
      onClick: s,
      children: [
        /* @__PURE__ */ e("figure", { className: "b-h-5 b-w-5 b-p-0 b-m-0 b-mr-2", children: r }),
        /* @__PURE__ */ e("div", { className: "b-text-ellipsis b-w-full b-text-nowrap b-overflow-hidden", children: a })
      ]
    }
  );
}
function K({ searchBarProps: r }) {
  return /* @__PURE__ */ e("div", { className: "b-h-9 b-w-full", children: /* @__PURE__ */ e(
    z,
    {
      ...r,
      buttonProps: {
        style: { height: "25px", display: "flex", alignItems: "center" }
      },
      resultsContainerProps: { style: { paddingTop: "30px" } }
    }
  ) });
}
function z({
  onSearch: r,
  results: a,
  isLoading: s,
  textPlaceholder: p,
  onFail: g,
  noResultsChildren: v,
  buttonProps: S = {},
  resultsContainerProps: N = {},
  inputContainerProps: w = {},
  showErrorChildren: b = !1,
  errorChildren: x
}) {
  const c = B(null), [n, i] = y(!1), u = () => {
    i(!1);
  }, h = () => {
    i(!0);
  };
  return P({
    isOpen: n,
    close: u,
    ref: c
  }), /* @__PURE__ */ e("div", { className: "b-w-full b-h-full", ref: c, children: /* @__PURE__ */ e(
    R,
    {
      onSubmit: (l) => r(l.searchValue),
      onSubmitFail: g,
      formProps: {
        defaultValues: {
          searchValue: ""
        }
      },
      formElementProps: {
        className: "b-h-full"
      },
      children: /* @__PURE__ */ t("div", { className: "b-relative b-z-20 b-w-full b-h-full", children: [
        /* @__PURE__ */ e(
          "div",
          {
            className: "b-bg-gray-50 b-rounded-2xl b-border-solid b-border-[1px] b-border-[#ced4da]",
            ...w,
            children: /* @__PURE__ */ e(
              F,
              {
                id: "searchValue",
                inputProps: {
                  mask: "",
                  type: "search",
                  placeholder: p,
                  id: "searchValue",
                  autoComplete: "off",
                  className: "b-pr-1  b-h-full b-bg-transparent",
                  "aria-describedby": "search-icon",
                  onFocus: h
                },
                rightContent: /* @__PURE__ */ e(
                  "button",
                  {
                    id: "search-icon",
                    type: "submit",
                    className: "hover:b-cursor-pointer b-flex b-border-none b-bg-transparent b-p-0",
                    ...S,
                    children: /* @__PURE__ */ e("img", { className: "b-h-5 b-w-5", src: j, alt: "search" })
                  }
                ),
                registerProps: {
                  onChange: k((l) => {
                    var m;
                    const d = l;
                    if (d.target.value.length < 4) {
                      u();
                      return;
                    }
                    n || h(), (m = d.target.form) == null || m.requestSubmit();
                  }, 300)
                }
              }
            )
          }
        ),
        n && /* @__PURE__ */ t(
          "div",
          {
            className: "b-border-solid b-border-t-0 b-border-[1px] b-border-[#ced4da] b-ml-0 -b-z-10 b-overflow-hidden b-absolute b-bg-white b-w-full b-rounded-2xl b-pt-6 b-top-[40%]",
            ...N,
            children: [
              !b && /* @__PURE__ */ e(f, { children: s ? /* @__PURE__ */ e("div", { className: "b-w-full b-pb-3 b-flex b-justify-center", children: /* @__PURE__ */ e(
                "img",
                {
                  src: H,
                  alt: "Loading",
                  className: "b-w-5 b-h-5"
                }
              ) }) : /* @__PURE__ */ t(f, { children: [
                a.map((l) => /* @__PURE__ */ e(C, { children: l.children }, l.id)),
                a.length === 0 && /* @__PURE__ */ e("div", { className: "b-pt-0 b-pr-0 b-pb-4 b-pl-2", children: v })
              ] }) }),
              b && x
            ]
          }
        )
      ] })
    }
  ) });
}
export {
  K as HeaderSearchBar,
  z as SearchBar,
  D as SearchBarHashtagResultItem,
  E as SearchBarLocationResultItem,
  J as SearchBarPersonResultItem
};
